var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"callback-container"},[_c('div',{staticClass:"loading-spinner"}),_c('p',{staticClass:"loading-text"},[_vm._v("게임을 불러오는 중...")])])
}]

export { render, staticRenderFns }